module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/143-norway-56f62ee126a4887a6dd280a5eda0030b.svg";